(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["antesdespues"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    const movimientoReducido = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function limitar(valor) {
      return Math.min(100, Math.max(0, valor));
    }

    function preparar(raiz) {
      const marco = raiz.querySelector('[data-azurel-marco]');
      const control = raiz.querySelector('[data-azurel-control]');
      if (!marco || !control) return;

      let animando = false;
      let cancelado = false;

      function fijar(valor) {
        const limpio = limitar(valor);
        marco.style.setProperty('--ad-posicion', limpio + '%');
        control.value = String(limpio);
      }

      function cancelarDemo() {
        cancelado = true;
        animando = false;
      }

      function suavizar(t) {
        return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
      }

      function mover(desde, hasta, duracion) {
        return new Promise(function (resolver) {
          const inicio = performance.now();
          function paso(ahora) {
            if (cancelado) return resolver(false);
            const progreso = Math.min(1, (ahora - inicio) / duracion);
            fijar(desde + (hasta - desde) * suavizar(progreso));
            if (progreso < 1) {
              requestAnimationFrame(paso);
            } else {
              resolver(true);
            }
          }
          requestAnimationFrame(paso);
        });
      }

      function demostrar() {
        if (animando || cancelado) return;
        animando = true;
        const inicial = parseFloat(control.value) || 50;
        mover(inicial, 22, 700)
          .then(function (continua) { return continua ? mover(22, 78, 1100) : false; })
          .then(function (continua) { return continua ? mover(78, inicial, 700) : false; })
          .then(function () { animando = false; });
      }

      control.addEventListener('input', function () {
        cancelarDemo();
        fijar(parseFloat(control.value) || 0);
      });

      ['pointerdown', 'touchstart', 'keydown'].forEach(function (evento) {
        control.addEventListener(evento, cancelarDemo, { passive: true });
      });

      fijar(parseFloat(control.value) || 50);

      if (raiz.dataset.demo === 'true' && !movimientoReducido && 'IntersectionObserver' in window) {
        const observador = new IntersectionObserver(function (entradas) {
          entradas.forEach(function (entrada) {
            if (entrada.isIntersecting) {
              observador.disconnect();
              setTimeout(demostrar, 300);
            }
          });
        }, { threshold: 0.6 });
        observador.observe(marco);
      }
    }

    function iniciar() {
      document.querySelectorAll('[data-azurel-antes-despues]').forEach(function (raiz) {
        if (raiz.dataset.iniciado === 'true') return;
        raiz.dataset.iniciado = 'true';
        preparar(raiz);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', iniciar);
    } else {
      iniciar();
    }

    document.addEventListener('shopify:section:load', iniciar);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["botonfijo"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    const selectorFormulario = 'form[action*="/cart/add"]';
    let temporizadorAviso = null;

    function formularioTema(raiz) {
      const formularios = Array.prototype.slice.call(document.querySelectorAll(selectorFormulario));
      for (let i = 0; i < formularios.length; i += 1) {
        if (!raiz.contains(formularios[i])) return formularios[i];
      }
      return null;
    }

    function botonDelTema(raiz) {
      const selector = raiz.dataset.selectorTema;
      if (!selector) return null;
      let candidatos = [];
      try {
        candidatos = Array.prototype.slice.call(document.querySelectorAll(selector));
      } catch (error) {
        return null;
      }
      for (let i = 0; i < candidatos.length; i += 1) {
        if (!raiz.contains(candidatos[i])) return candidatos[i];
      }
      return null;
    }

    function identificadorVariante(raiz) {
      const formulario = formularioTema(raiz);
      const campo = formulario ? formulario.querySelector('[name="id"]') : null;
      return campo && campo.value ? Number(campo.value) : Number(raiz.dataset.variante);
    }

    function cantidad(raiz) {
      if (raiz.dataset.leerCantidad !== 'true') return 1;
      const formulario = formularioTema(raiz);
      const campo = formulario ? formulario.querySelector('input[name="quantity"]') : null;
      const valor = campo ? parseInt(campo.value, 10) : 1;
      return valor > 0 ? valor : 1;
    }

    function mostrarAviso(raiz, texto, esError, duracion) {
      const aviso = raiz.querySelector('[data-azurel-barra-aviso]');
      if (!aviso) return;
      clearTimeout(temporizadorAviso);
      aviso.textContent = texto || '';
      aviso.classList.toggle('azurel-barra-compra__aviso--error', Boolean(esError));
      aviso.hidden = !texto;
      if (texto && duracion) {
        temporizadorAviso = setTimeout(function () {
          aviso.hidden = true;
        }, duracion);
      }
    }

    function anadirDirecto(raiz, boton) {
      const raizRutas = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
      const textoOriginal = boton.dataset.texto || boton.textContent;
      const accion = raiz.dataset.accion || 'carrito';

      mostrarAviso(raiz, '', false, 0);
      boton.disabled = true;
      boton.textContent = raiz.dataset.textoCargando || textoOriginal;

      fetch(raizRutas + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          items: [{ id: identificadorVariante(raiz), quantity: cantidad(raiz) }]
        })
      })
        .then(function (respuesta) {
          if (!respuesta.ok) throw new Error('error');
          return respuesta.json();
        })
        .then(function () {
          if (accion === 'pagar') {
            window.location.href = raizRutas + 'checkout';
            return;
          }
          if (accion === 'carrito') {
            window.location.href = raiz.dataset.urlCarrito || '/cart';
            return;
          }
          boton.disabled = false;
          boton.textContent = textoOriginal;
          mostrarAviso(raiz, raiz.dataset.textoAnadido || '', false, 3000);
        })
        .catch(function () {
          boton.disabled = false;
          boton.textContent = textoOriginal;
          mostrarAviso(raiz, raiz.dataset.textoError || '', true, 5000);
        });
    }

    function anadirConTema(raiz, boton) {
      const botonTema = botonDelTema(raiz);
      if (!botonTema) {
        anadirDirecto(raiz, boton);
        return;
      }
      if (botonTema.disabled || botonTema.getAttribute('aria-disabled') === 'true') return;

      const textoOriginal = boton.dataset.texto || boton.textContent;
      boton.disabled = true;
      boton.textContent = raiz.dataset.textoCargando || textoOriginal;
      botonTema.click();
      setTimeout(function () {
        boton.disabled = false;
        boton.textContent = textoOriginal;
      }, 1400);
    }

    function prepararVisibilidad(raiz) {
      const minimo = parseFloat(raiz.dataset.minimo) || 0;
      const selector = raiz.dataset.selectorObservado || '';
      const visibles = new Set();
      let observador = null;
      let pendiente = false;

      function medir() {
        const altura = raiz.offsetHeight || 0;
        if (raiz.dataset.posicion === 'abajo') {
          document.documentElement.style.setProperty('--azurel-barra-altura', altura + 'px');
          document.documentElement.classList.add('azurel-barra-compra-activa');
        }
      }

      function evaluar() {
        const mostrar = window.scrollY > minimo && visibles.size === 0;
        raiz.classList.toggle('azurel-barra-compra--visible', mostrar);
        raiz.setAttribute('aria-hidden', mostrar ? 'false' : 'true');
        medir();
      }

      function observar() {
        visibles.clear();
        if (observador) observador.disconnect();
        if (!('IntersectionObserver' in window) || !selector) {
          evaluar();
          return;
        }
        let elementos = [];
        try {
          elementos = Array.prototype.slice.call(document.querySelectorAll(selector));
        } catch (error) {
          elementos = [];
        }
        observador = new IntersectionObserver(function (entradas) {
          entradas.forEach(function (entrada) {
            if (entrada.isIntersecting) {
              visibles.add(entrada.target);
            } else {
              visibles.delete(entrada.target);
            }
          });
          evaluar();
        });
        elementos.forEach(function (elemento) {
          if (!raiz.contains(elemento)) observador.observe(elemento);
        });
        evaluar();
      }

      window.addEventListener('scroll', function () {
        if (pendiente) return;
        pendiente = true;
        requestAnimationFrame(function () {
          pendiente = false;
          evaluar();
        });
      }, { passive: true });

      window.addEventListener('resize', medir);
      window.addEventListener('load', observar);
      observar();
    }

    function preparar(raiz) {
      const boton = raiz.querySelector('[data-azurel-barra-anadir]');
      if (boton) {
        boton.addEventListener('click', function () {
          if (raiz.dataset.modo === 'directo') {
            anadirDirecto(raiz, boton);
          } else {
            anadirConTema(raiz, boton);
          }
        });
      }
      prepararVisibilidad(raiz);
    }

    function iniciar() {
      document.querySelectorAll('[data-azurel-barra-compra]').forEach(function (raiz) {
        if (raiz.dataset.iniciado === 'true') return;
        raiz.dataset.iniciado = 'true';
        preparar(raiz);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', iniciar);
    } else {
      iniciar();
    }

    document.addEventListener('shopify:section:load', iniciar);

    document.addEventListener('shopify:section:unload', function () {
      document.documentElement.classList.remove('azurel-barra-compra-activa');
      document.documentElement.style.removeProperty('--azurel-barra-altura');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bundle"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    const selectorFormulario = 'form[action*="/cart/add"]';

    function formulariosTema() {
      return Array.prototype.slice.call(document.querySelectorAll(selectorFormulario)).filter(function (formulario) {
        return !formulario.closest('[data-azurel-filas]');
      });
    }

    function aplicarAFormulario(formulario, unidades) {
      let entrada = formulario.querySelector('input[name="quantity"]');
      if (!entrada) {
        entrada = document.createElement('input');
        entrada.type = 'hidden';
        entrada.name = 'quantity';
        formulario.appendChild(entrada);
      }
      if (String(entrada.value) === String(unidades)) return;
      entrada.value = unidades;
      entrada.dispatchEvent(new Event('input', { bubbles: true }));
      entrada.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function sincronizarCantidad(unidades) {
      formulariosTema().forEach(function (formulario) {
        aplicarAFormulario(formulario, unidades);
      });
    }

    function unidadesSeleccionadas(raiz) {
      const marcada = raiz.querySelector('.azurel-filas__radio:checked');
      return marcada ? parseInt(marcada.dataset.unidades, 10) || 1 : 1;
    }

    function identificadorVariante(boton) {
      const formulario = formulariosTema()[0];
      const campo = formulario ? formulario.querySelector('[name="id"]') : null;
      return campo && campo.value ? Number(campo.value) : Number(boton.dataset.variante);
    }

    function mostrarMensaje(raiz, texto, esError) {
      const mensaje = raiz.querySelector('[data-azurel-filas-mensaje]');
      if (!mensaje) return;
      mensaje.textContent = texto || '';
      mensaje.style.setProperty('color', esError ? '' : 'inherit', 'important');
      mensaje.hidden = !texto;
    }

    function anadirAlCarrito(raiz, boton) {
      const raizRutas = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
      const textoOriginal = boton.dataset.texto || boton.textContent;
      const accion = raiz.dataset.accion || 'carrito';

      mostrarMensaje(raiz, '', true);
      boton.disabled = true;
      boton.textContent = raiz.dataset.textoCargando || textoOriginal;

      fetch(raizRutas + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          items: [{ id: identificadorVariante(boton), quantity: unidadesSeleccionadas(raiz) }]
        })
      })
        .then(function (respuesta) {
          if (!respuesta.ok) throw new Error('error');
          return respuesta.json();
        })
        .then(function () {
          if (accion === 'pagar') {
            window.location.href = raizRutas + 'checkout';
            return;
          }
          if (accion === 'carrito') {
            window.location.href = raiz.dataset.urlCarrito || '/cart';
            return;
          }
          boton.disabled = false;
          boton.textContent = textoOriginal;
          mostrarMensaje(raiz, raiz.dataset.textoAnadido || '', false);
          document.dispatchEvent(new CustomEvent('azurel:carrito-actualizado'));
        })
        .catch(function () {
          boton.disabled = false;
          boton.textContent = textoOriginal;
          mostrarMensaje(raiz, raiz.dataset.textoError || '', true);
        });
    }

    function ocultarBotonTema(raiz) {
      if (raiz.dataset.ocultarTema !== 'true') return;
      const selector = raiz.dataset.selectorTema;
      if (!selector) return;
      try {
        document.querySelectorAll(selector).forEach(function (elemento) {
          if (!elemento.closest('[data-azurel-filas]')) {
            elemento.style.setProperty('display', 'none', 'important');
          }
        });
      } catch (error) {
        return;
      }
    }

    function iniciar() {
      document.querySelectorAll('[data-azurel-filas]').forEach(function (raiz) {
        ocultarBotonTema(raiz);

        if (raiz.dataset.iniciado === 'true') return;
        raiz.dataset.iniciado = 'true';

        const sincronizar = raiz.dataset.sincronizar === 'true';

        raiz.querySelectorAll('.azurel-filas__radio').forEach(function (opcion) {
          opcion.addEventListener('change', function () {
            if (sincronizar) sincronizarCantidad(unidadesSeleccionadas(raiz));
          });
        });

        if (sincronizar) sincronizarCantidad(unidadesSeleccionadas(raiz));

        const boton = raiz.querySelector('[data-azurel-filas-anadir]');
        if (boton) {
          boton.addEventListener('click', function () {
            anadirAlCarrito(raiz, boton);
          });
        }
      });
    }

    document.addEventListener(
      'submit',
      function (evento) {
        const formulario = evento.target;
        if (!formulario || !formulario.matches || !formulario.matches(selectorFormulario)) return;
        if (formulario.closest('[data-azurel-filas]')) return;
        const raiz = document.querySelector('[data-azurel-filas][data-sincronizar="true"]');
        if (!raiz) return;
        aplicarAFormulario(formulario, unidadesSeleccionadas(raiz));
      },
      true
    );

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', iniciar);
    } else {
      iniciar();
    }

    window.addEventListener('load', iniciar);
    document.addEventListener('shopify:section:load', iniciar);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["descuento"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    function leer(clave) {
      try {
        return window.localStorage.getItem(clave);
      } catch (error) {
        return null;
      }
    }

    function guardar(clave, valor) {
      try {
        window.localStorage.setItem(clave, valor);
      } catch (error) {
        return;
      }
    }

    function preparar(raiz) {
      const ventana = raiz.querySelector('[data-azurel-popup-ventana]');
      if (!ventana) return;

      const clave = raiz.dataset.clave;
      const dias = parseFloat(raiz.dataset.dias);
      const esModal = raiz.dataset.formato === 'centro';
      const enEditor = raiz.dataset.editor === 'true';
      const cierres = raiz.querySelectorAll('[data-azurel-popup-cerrar]');
      const fondo = raiz.querySelector('[data-azurel-popup-fondo]');
      const formulario = raiz.querySelector('form');
      const botonCopiar = raiz.querySelector('[data-azurel-popup-copiar]');
      const selectorEnfocables = 'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])';
      let abierto = false;
      let lanzado = false;
      let anteriorFoco = null;

      function visible(elemento) {
        return elemento.offsetParent !== null || elemento === document.activeElement;
      }

      function abrir() {
        if (abierto) return;
        abierto = true;
        anteriorFoco = document.activeElement;
        raiz.classList.add('azurel-popup--abierto');
        raiz.setAttribute('aria-hidden', 'false');
        if (esModal) document.documentElement.classList.add('azurel-popup-bloqueado');
        if (!enEditor) guardar(clave + '-visto', String(Date.now()));
        setTimeout(function () {
          const primero = ventana.querySelector('.azurel-popup__vista:not([style*="none"]) input[type="email"]');
          const visibleEntrada = primero && primero.offsetParent !== null ? primero : null;
          const destino = visibleEntrada || ventana.querySelector('[data-azurel-popup-cerrar]');
          if (destino && destino.focus) destino.focus();
        }, 80);
      }

      function cerrar() {
        if (!abierto) return;
        abierto = false;
        raiz.classList.remove('azurel-popup--abierto');
        raiz.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('azurel-popup-bloqueado');
        if (anteriorFoco && anteriorFoco.focus) anteriorFoco.focus();
      }

      function puedeMostrar() {
        if (enEditor) return true;
        if (leer(clave + '-suscrito') === '1') return false;
        const visto = parseInt(leer(clave + '-visto'), 10);
        if (visto && dias > 0 && Date.now() - visto < dias * 86400000) return false;
        if (visto && !(dias > 0)) return true;
        return true;
      }

      function lanzar() {
        if (lanzado || !puedeMostrar()) return;
        lanzado = true;
        abrir();
      }

      function mostrarExito() {
        raiz.dataset.estado = 'exito';
        guardar(clave + '-suscrito', '1');
        const titulo = raiz.querySelector('[data-azurel-popup-titulo-exito]');
        if (titulo) setTimeout(function () { titulo.focus(); }, 60);
      }

      function mostrarFallo(boton, textoOriginal) {
        boton.disabled = false;
        boton.textContent = textoOriginal;
        const error = raiz.querySelector('[data-azurel-popup-error]');
        if (error) error.hidden = false;
      }

      function copiarCodigo() {
        const codigo = raiz.dataset.codigo;
        if (!codigo || !botonCopiar) return;
        const restaurar = function () {
          setTimeout(function () {
            botonCopiar.textContent = raiz.dataset.textoCopiar || 'Copiar';
          }, 2000);
        };
        const confirmar = function () {
          botonCopiar.textContent = raiz.dataset.textoCopiado || 'Copiado';
          restaurar();
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(codigo).then(confirmar, function () {});
          return;
        }
        const auxiliar = document.createElement('textarea');
        auxiliar.value = codigo;
        auxiliar.setAttribute('readonly', '');
        auxiliar.style.position = 'fixed';
        auxiliar.style.opacity = '0';
        document.body.appendChild(auxiliar);
        auxiliar.select();
        try {
          document.execCommand('copy');
          confirmar();
        } catch (error) {
          return;
        } finally {
          document.body.removeChild(auxiliar);
        }
      }

      function iniciarDisparador() {
        const modo = raiz.dataset.disparador;
        const retraso = (parseFloat(raiz.dataset.retraso) || 8) * 1000;
        const umbral = parseFloat(raiz.dataset.scroll) || 40;

        if (modo === 'scroll') {
          const alDesplazar = function () {
            const total = document.documentElement.scrollHeight - window.innerHeight;
            if (total <= 0) return;
            if ((window.scrollY / total) * 100 >= umbral) {
              window.removeEventListener('scroll', alDesplazar);
              lanzar();
            }
          };
          window.addEventListener('scroll', alDesplazar, { passive: true });
          return;
        }

        if (modo === 'salida') {
          const tactil = window.matchMedia && window.matchMedia('(hover: none)').matches;
          if (tactil) {
            setTimeout(lanzar, retraso);
            return;
          }
          setTimeout(function () {
            const alSalir = function (evento) {
              if (!evento.relatedTarget && evento.clientY <= 0) {
                document.removeEventListener('mouseout', alSalir);
                lanzar();
              }
            };
            document.addEventListener('mouseout', alSalir);
          }, 3000);
          return;
        }

        setTimeout(lanzar, retraso);
      }

      cierres.forEach(function (elemento) {
        elemento.addEventListener('click', cerrar);
      });

      if (fondo) {
        fondo.addEventListener('click', function () {
          if (raiz.dataset.cerrarFondo === 'true') cerrar();
        });
      }

      if (botonCopiar) botonCopiar.addEventListener('click', copiarCodigo);

      document.addEventListener('keydown', function (evento) {
        if (!abierto) return;
        if (evento.key === 'Escape') {
          cerrar();
          return;
        }
        if (evento.key !== 'Tab' || !esModal) return;
        const enfocables = Array.prototype.slice.call(ventana.querySelectorAll(selectorEnfocables)).filter(visible);
        if (!enfocables.length) return;
        const primero = enfocables[0];
        const ultimo = enfocables[enfocables.length - 1];
        if (evento.shiftKey && document.activeElement === primero) {
          evento.preventDefault();
          ultimo.focus();
        } else if (!evento.shiftKey && document.activeElement === ultimo) {
          evento.preventDefault();
          primero.focus();
        }
      });

      if (formulario) {
        formulario.addEventListener('submit', function (evento) {
          if (!window.fetch || !window.FormData) return;
          evento.preventDefault();

          const boton = formulario.querySelector('[data-azurel-popup-enviar]');
          const error = raiz.querySelector('[data-azurel-popup-error]');
          const textoOriginal = boton.dataset.texto || boton.textContent;
          if (error) error.hidden = true;
          boton.disabled = true;
          boton.textContent = raiz.dataset.textoCargando || textoOriginal;

          fetch(formulario.getAttribute('action') || '/contact', {
            method: 'POST',
            body: new FormData(formulario),
            credentials: 'same-origin',
            headers: { Accept: 'text/html' }
          })
            .then(function (respuesta) {
              return respuesta.text().then(function (texto) {
                return { url: respuesta.url, texto: texto };
              });
            })
            .then(function (resultado) {
              if (resultado.url.indexOf('/challenge') !== -1) {
                formulario.submit();
                return;
              }
              if (resultado.url.indexOf('customer_posted=true') !== -1 || resultado.texto.indexOf('data-azurel-popup-exito="true"') !== -1) {
                mostrarExito();
                return;
              }
              mostrarFallo(boton, textoOriginal);
            })
            .catch(function () {
              formulario.submit();
            });
        });
      }

      if (raiz.dataset.estado === 'exito') {
        guardar(clave + '-suscrito', '1');
      }

      if (enEditor || raiz.dataset.abrirYa === 'true') {
        lanzado = true;
        setTimeout(abrir, enEditor ? 300 : 150);
      } else {
        iniciarDisparador();
      }

      document.addEventListener('shopify:section:select', function (evento) {
        if (evento.target && evento.target.contains(raiz)) {
          lanzado = true;
          abrir();
        }
      });

      document.addEventListener('shopify:section:deselect', function (evento) {
        if (evento.target && evento.target.contains(raiz)) cerrar();
      });
    }

    function iniciar() {
      document.querySelectorAll('[data-azurel-popup]').forEach(function (raiz) {
        if (raiz.dataset.iniciado === 'true') return;
        raiz.dataset.iniciado = 'true';
        preparar(raiz);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', iniciar);
    } else {
      iniciar();
    }

    document.addEventListener('shopify:section:load', iniciar);

    document.addEventListener('shopify:section:unload', function () {
      document.documentElement.classList.remove('azurel-popup-bloqueado');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["envio"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    const meses = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
    let intervalo = null;

    function partesZona(zona) {
      let formato;
      try {
        formato = new Intl.DateTimeFormat('en-GB', {
          timeZone: zona,
          hourCycle: 'h23',
          year: 'numeric',
          month: 'numeric',
          day: 'numeric',
          hour: 'numeric',
          minute: 'numeric',
          second: 'numeric'
        });
      } catch (error) {
        formato = new Intl.DateTimeFormat('en-GB', {
          hourCycle: 'h23',
          year: 'numeric',
          month: 'numeric',
          day: 'numeric',
          hour: 'numeric',
          minute: 'numeric',
          second: 'numeric'
        });
      }
      const partes = {};
      formato.formatToParts(new Date()).forEach(function (parte) {
        partes[parte.type] = parseInt(parte.value, 10);
      });
      return partes;
    }

    function clave(fecha) {
      return fecha.toISOString().slice(0, 10);
    }

    function sumarDias(fecha, dias) {
      const copia = new Date(fecha.getTime());
      copia.setUTCDate(copia.getUTCDate() + dias);
      return copia;
    }

    function esLaborable(fecha, contarSabados, festivos) {
      const dia = fecha.getUTCDay();
      if (dia === 0) return false;
      if (dia === 6 && !contarSabados) return false;
      return festivos.indexOf(clave(fecha)) === -1;
    }

    function siguienteLaborable(fecha, contarSabados, festivos) {
      let siguiente = sumarDias(fecha, 1);
      let intentos = 0;
      while (!esLaborable(siguiente, contarSabados, festivos) && intentos < 60) {
        siguiente = sumarDias(siguiente, 1);
        intentos += 1;
      }
      return siguiente;
    }

    function formatearFecha(fecha, hoy, raiz) {
      const diferencia = Math.round((fecha.getTime() - hoy.getTime()) / 86400000);
      if (diferencia === 0 && raiz.dataset.textoHoy) return raiz.dataset.textoHoy;
      if (diferencia === 1 && raiz.dataset.textoManana) return raiz.dataset.textoManana;
      return fecha.getUTCDate() + ' de ' + meses[fecha.getUTCMonth()];
    }

    function dosDigitos(valor) {
      return valor < 10 ? '0' + valor : String(valor);
    }

    function formatearTiempo(segundos) {
      const horas = Math.floor(segundos / 3600);
      const minutos = Math.floor((segundos % 3600) / 60);
      if (horas > 0) return horas + ' h ' + minutos + ' min';
      return minutos + ' min ' + dosDigitos(segundos % 60) + ' s';
    }

    function rellenarTitulo(elemento, plantilla, marcador, valor) {
      const partes = plantilla.split(marcador);
      const firma = plantilla + '|' + valor;
      if (elemento.dataset.firma === firma) return;
      elemento.dataset.firma = firma;
      elemento.textContent = '';
      partes.forEach(function (parte, indice) {
        if (parte) elemento.appendChild(document.createTextNode(parte));
        if (indice < partes.length - 1) {
          const destacado = document.createElement('strong');
          destacado.textContent = valor;
          elemento.appendChild(destacado);
        }
      });
    }

    function actualizar(raiz) {
      const zona = raiz.dataset.zona || 'Europe/Madrid';
      const partes = partesZona(zona);
      const hoy = new Date(Date.UTC(partes.year, partes.month - 1, partes.day));
      const contarSabados = raiz.dataset.sabados === 'true';
      const festivos = (raiz.dataset.festivos || '').split(',').map(function (valor) {
        return valor.trim();
      }).filter(Boolean);

      const corte = (raiz.dataset.horaCorte || '15:00').match(/^(\d{1,2}):(\d{2})$/);
      const segundosCorte = corte ? parseInt(corte[1], 10) * 3600 + parseInt(corte[2], 10) * 60 : 15 * 3600;
      const segundosAhora = partes.hour * 3600 + partes.minute * 60 + partes.second;

      const saleHoy = esLaborable(hoy, contarSabados, festivos) && segundosAhora < segundosCorte;
      const salida = saleHoy ? hoy : siguienteLaborable(hoy, contarSabados, festivos);

      let entrega = salida;
      const diasEntrega = parseInt(raiz.dataset.diasEntrega, 10) || 0;
      for (let i = 0; i < diasEntrega; i += 1) {
        entrega = siguienteLaborable(entrega, contarSabados, festivos);
      }

      const titulo = raiz.querySelector('[data-azurel-entrega-titulo]');
      if (titulo) {
        if (saleHoy) {
          rellenarTitulo(titulo, raiz.dataset.textoAntes || '', '{tiempo}', formatearTiempo(segundosCorte - segundosAhora));
        } else {
          rellenarTitulo(titulo, raiz.dataset.textoDespues || '', '{fecha}', formatearFecha(salida, hoy, raiz));
        }
      }

      raiz.querySelectorAll('[data-azurel-fecha]').forEach(function (elemento) {
        const tipo = elemento.dataset.azurelFecha;
        let texto = null;
        if (tipo === 'hoy') texto = formatearFecha(hoy, hoy, raiz);
        if (tipo === 'salida') texto = formatearFecha(salida, hoy, raiz);
        if (tipo === 'entrega') texto = formatearFecha(entrega, hoy, raiz);
        if (texto !== null && elemento.textContent !== texto) elemento.textContent = texto;
      });
    }

    function actualizarTodo() {
      document.querySelectorAll('[data-azurel-entrega]').forEach(actualizar);
    }

    function iniciar() {
      actualizarTodo();
      if (!intervalo) intervalo = setInterval(actualizarTodo, 1000);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', iniciar);
    } else {
      iniciar();
    }

    document.addEventListener('shopify:section:load', actualizarTodo);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fyq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    function preparar(raiz) {
      if (raiz.dataset.unaSola !== 'true') return;
      const items = Array.prototype.slice.call(raiz.querySelectorAll('.azurel-faq__item'));

      items.forEach(function (item) {
        item.addEventListener('toggle', function () {
          if (!item.open) return;
          items.forEach(function (otro) {
            if (otro !== item && otro.open) otro.open = false;
          });
        });
      });

      const abiertos = items.filter(function (item) { return item.open; });
      abiertos.slice(1).forEach(function (item) { item.open = false; });
    }

    function iniciar() {
      document.querySelectorAll('[data-azurel-faq]').forEach(function (raiz) {
        if (raiz.dataset.iniciado === 'true') return;
        raiz.dataset.iniciado = 'true';
        preparar(raiz);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', iniciar);
    } else {
      iniciar();
    }

    document.addEventListener('shopify:section:load', iniciar);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-2"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    const patronCarrito = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
    const fetchOriginal = typeof window.fetch === 'function' ? window.fetch.bind(window) : null;
    let temporizadorCarrito;
    let suscritoAPubSub = false;
    let fetchEnvuelto = false;

    function rutaCarrito() {
      const raiz = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
      return raiz + 'cart.js';
    }

    function pintarContador(cantidad) {
      document.querySelectorAll('[data-azurel-carrito]').forEach(function (enlace) {
        const contador = enlace.querySelector('[data-azurel-contador]');
        const etiqueta = enlace.dataset.etiqueta || '';
        const ocultarCero = enlace.dataset.ocultarCero === 'true';
        if (contador) {
          contador.textContent = cantidad > 99 ? '99+' : String(cantidad);
          contador.hidden = ocultarCero && cantidad === 0;
        }
        enlace.setAttribute('aria-label', etiqueta + ' (' + cantidad + ')');
      });
    }

    function refrescarCarrito() {
      if (!fetchOriginal) return;
      clearTimeout(temporizadorCarrito);
      temporizadorCarrito = setTimeout(function () {
        fetchOriginal(rutaCarrito(), {
          credentials: 'same-origin',
          cache: 'no-store',
          headers: { Accept: 'application/json' }
        })
          .then(function (respuesta) {
            return respuesta.json();
          })
          .then(function (carrito) {
            if (carrito && typeof carrito.item_count === 'number') {
              pintarContador(carrito.item_count);
            }
          })
          .catch(function () {});
      }, 150);
    }

    function envolverFetch() {
      if (fetchEnvuelto || !fetchOriginal) return;
      fetchEnvuelto = true;
      window.fetch = function (entrada) {
        const direccion = typeof entrada === 'string' ? entrada : (entrada && (entrada.url || entrada.href)) || '';
        const promesa = fetchOriginal.apply(null, arguments);
        if (patronCarrito.test(direccion)) {
          promesa.then(refrescarCarrito, function () {});
        }
        return promesa;
      };
    }

    function suscribirPubSub() {
      if (suscritoAPubSub) return;
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
        suscritoAPubSub = true;
        subscribe(PUB_SUB_EVENTS.cartUpdate, refrescarCarrito);
      }
    }

    function iniciarCajon(raiz) {
      const cajon = raiz.querySelector('[data-azurel-cajon]');
      const botonAbrir = raiz.querySelector('[data-azurel-abrir-menu]');
      if (!cajon || !botonAbrir) return;

      const cerradores = cajon.querySelectorAll('[data-azurel-cerrar-menu]');
      const botonCerrar = cajon.querySelector('button[data-azurel-cerrar-menu]');
      const selectorEnfocables = 'a[href], button:not([disabled]), summary, [tabindex]:not([tabindex="-1"])';

      function abrir() {
        cajon.classList.add('azurel-encabezado__cajon--abierto');
        cajon.setAttribute('aria-hidden', 'false');
        botonAbrir.setAttribute('aria-expanded', 'true');
        document.documentElement.classList.add('azurel-encabezado-bloqueado');
        setTimeout(function () {
          if (botonCerrar) botonCerrar.focus();
        }, 60);
      }

      function cerrar(devolverFoco) {
        cajon.classList.remove('azurel-encabezado__cajon--abierto');
        cajon.setAttribute('aria-hidden', 'true');
        botonAbrir.setAttribute('aria-expanded', 'false');
        document.documentElement.classList.remove('azurel-encabezado-bloqueado');
        if (devolverFoco) botonAbrir.focus();
      }

      botonAbrir.addEventListener('click', abrir);

      cerradores.forEach(function (elemento) {
        elemento.addEventListener('click', function () {
          cerrar(true);
        });
      });

      cajon.addEventListener('keydown', function (evento) {
        if (evento.key === 'Escape') {
          cerrar(true);
          return;
        }
        if (evento.key !== 'Tab') return;

        const enfocables = Array.from(cajon.querySelectorAll(selectorEnfocables)).filter(function (elemento) {
          return elemento.offsetParent !== null;
        });
        if (!enfocables.length) return;

        const primero = enfocables[0];
        const ultimo = enfocables[enfocables.length - 1];

        if (evento.shiftKey && document.activeElement === primero) {
          evento.preventDefault();
          ultimo.focus();
        } else if (!evento.shiftKey && document.activeElement === ultimo) {
          evento.preventDefault();
          primero.focus();
        }
      });
    }

    function iniciarCarrito(raiz) {
      const enlace = raiz.querySelector('[data-azurel-carrito]');
      if (!enlace || enlace.dataset.cajonTema !== 'true') return;

      enlace.addEventListener('click', function (evento) {
        const cajonTema = document.querySelector('cart-drawer');
        if (!cajonTema || typeof cajonTema.open !== 'function') return;
        if (/\/cart\/?$/.test(window.location.pathname)) return;
        evento.preventDefault();
        cajonTema.open(enlace);
      });
    }

    function iniciarFijo(raiz) {
      if (raiz.dataset.fijo !== 'true') return;
      const contenedor = raiz.closest('.shopify-section');
      if (contenedor) contenedor.classList.add('azurel-encabezado-seccion--fija');
    }

    function iniciar() {
      document.querySelectorAll('[data-azurel-encabezado]').forEach(function (raiz) {
        if (raiz.dataset.iniciado === 'true') return;
        raiz.dataset.iniciado = 'true';
        iniciarCajon(raiz);
        iniciarCarrito(raiz);
        iniciarFijo(raiz);
      });
      suscribirPubSub();
      envolverFetch();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', iniciar);
    } else {
      iniciar();
    }

    window.addEventListener('load', suscribirPubSub);

    window.addEventListener('pageshow', function (evento) {
      if (evento.persisted) refrescarCarrito();
    });

    document.addEventListener('shopify:section:load', iniciar);

    document.addEventListener('shopify:section:unload', function () {
      document.documentElement.classList.remove('azurel-encabezado-bloqueado');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-contador-barra-movil"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    const objetivos = new WeakMap();

    function dosDigitos(valor) {
      return valor < 10 ? '0' + valor : String(valor);
    }

    function convertirZona(anio, mes, dia, hora, minuto, zona) {
      const formato = new Intl.DateTimeFormat('en-US', {
        timeZone: zona,
        hourCycle: 'h23',
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric'
      });

      function desfase(marca) {
        const partes = {};
        formato.formatToParts(new Date(marca)).forEach(function (parte) {
          partes[parte.type] = parte.value;
        });
        return Date.UTC(+partes.year, +partes.month - 1, +partes.day, +partes.hour, +partes.minute, +partes.second) - marca;
      }

      const base = Date.UTC(anio, mes - 1, dia, hora, minuto, 0);
      const primera = base - desfase(base);
      return base - desfase(primera);
    }

    function calcularObjetivo(elemento) {
      const fecha = (elemento.dataset.fecha || '').trim().match(/^(\d{4})-(\d{1,2})-(\d{1,2})$/);
      const hora = (elemento.dataset.hora || '').trim().match(/^(\d{1,2}):(\d{2})$/);
      if (!fecha) return null;

      const anio = +fecha[1];
      const mes = +fecha[2];
      const dia = +fecha[3];
      const horas = hora ? +hora[1] : 23;
      const minutos = hora ? +hora[2] : 59;

      try {
        return convertirZona(anio, mes, dia, horas, minutos, elemento.dataset.zona || 'Europe/Madrid');
      } catch (error) {
        return new Date(anio, mes - 1, dia, horas, minutos, 0).getTime();
      }
    }

    function escribir(elemento, unidad, valor) {
      const nodo = elemento.querySelector('[data-azurel-unidad="' + unidad + '"]');
      if (nodo && nodo.textContent !== valor) nodo.textContent = valor;
    }

    function actualizarCuentas() {
      document.querySelectorAll('[data-azurel-cuenta-atras]').forEach(function (elemento) {
        if (!objetivos.has(elemento)) objetivos.set(elemento, calcularObjetivo(elemento));
        const objetivo = objetivos.get(elemento);
        if (objetivo === null) return;

        const resto = Math.max(0, Math.floor((objetivo - Date.now()) / 1000));
        escribir(elemento, 'dias', String(Math.floor(resto / 86400)));
        escribir(elemento, 'horas', dosDigitos(Math.floor((resto % 86400) / 3600)));
        escribir(elemento, 'minutos', dosDigitos(Math.floor((resto % 3600) / 60)));
        escribir(elemento, 'segundos', dosDigitos(resto % 60));

        if (resto === 0 && elemento.dataset.alTerminar === 'ocultar') {
          elemento.hidden = true;
        }
      });
    }

    function prepararMarquesina(marquesina, forzar) {
      const pista = marquesina.querySelector('.azurel-cabecera__pista');
      const grupo = pista ? pista.querySelector('.azurel-cabecera__grupo:not([data-copia])') : null;
      if (!pista || !grupo) return;

      const anchoActual = marquesina.offsetWidth;
      if (!forzar && marquesina.dataset.anchoPrevio === String(anchoActual)) return;
      marquesina.dataset.anchoPrevio = String(anchoActual);

      pista.querySelectorAll('[data-copia]').forEach(function (copia) {
        copia.remove();
      });
      grupo.querySelectorAll('[data-clon]').forEach(function (clon) {
        clon.remove();
      });

      const originales = Array.from(grupo.children);
      if (!originales.length || anchoActual === 0) return;

      let intentos = 0;
      while (grupo.getBoundingClientRect().width < anchoActual && intentos < 20) {
        originales.forEach(function (original) {
          const clon = original.cloneNode(true);
          clon.setAttribute('data-clon', '');
          clon.setAttribute('aria-hidden', 'true');
          grupo.appendChild(clon);
        });
        intentos += 1;
      }

      const copiaGrupo = grupo.cloneNode(true);
      copiaGrupo.setAttribute('data-copia', '');
      copiaGrupo.setAttribute('aria-hidden', 'true');
      copiaGrupo.querySelectorAll('a').forEach(function (enlace) {
        enlace.setAttribute('tabindex', '-1');
      });
      pista.appendChild(copiaGrupo);

      const anchoGrupo = grupo.getBoundingClientRect().width;
      const velocidad = parseFloat(marquesina.dataset.velocidad) || 50;
      if (anchoGrupo > 0) {
        pista.style.setProperty('--ac-duracion', (anchoGrupo / velocidad) + 's');
      }
    }

    function prepararMarquesinas(forzar) {
      document.querySelectorAll('[data-azurel-marquesina]').forEach(function (marquesina) {
        prepararMarquesina(marquesina, forzar);
      });
    }

    function iniciar() {
      actualizarCuentas();
      prepararMarquesinas(true);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', iniciar);
    } else {
      iniciar();
    }

    window.addEventListener('load', function () {
      prepararMarquesinas(true);
    });

    let temporizadorRedimension;
    window.addEventListener('resize', function () {
      clearTimeout(temporizadorRedimension);
      temporizadorRedimension = setTimeout(function () {
        prepararMarquesinas(false);
      }, 200);
    });

    document.addEventListener('shopify:section:load', iniciar);

    setInterval(actualizarCuentas, 1000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredientes"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    const movimientoReducido = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function preparar(raiz) {
      const pista = raiz.querySelector('[data-azurel-pista]');
      const anterior = raiz.querySelector('[data-azurel-anterior]');
      const siguiente = raiz.querySelector('[data-azurel-siguiente]');
      const relleno = raiz.querySelector('[data-azurel-relleno]');
      const controles = raiz.querySelector('[data-azurel-controles]');
      if (!pista) return;

      let temporizador = null;
      let pausado = false;

      function paso() {
        const item = pista.querySelector('.azurel-ingredientes__item');
        if (!item) return pista.clientWidth;
        const hueco = parseFloat(window.getComputedStyle(pista).columnGap) || 0;
        return item.getBoundingClientRect().width + hueco;
      }

      function actualizar() {
        const maximo = pista.scrollWidth - pista.clientWidth;
        const hayDesplazamiento = maximo > 2;
        if (controles) controles.hidden = !hayDesplazamiento;
        if (!hayDesplazamiento) return;

        const proporcion = (pista.clientWidth / pista.scrollWidth) * 100;
        const avance = pista.scrollLeft / maximo;
        if (relleno) {
          relleno.style.width = proporcion + '%';
          relleno.style.left = avance * (100 - proporcion) + '%';
        }
        if (anterior) anterior.disabled = pista.scrollLeft <= 2;
        if (siguiente) siguiente.disabled = pista.scrollLeft >= maximo - 2;
      }

      function desplazar(direccion) {
        pista.scrollBy({ left: direccion * paso(), behavior: movimientoReducido ? 'auto' : 'smooth' });
      }

      function avanzarAutomatico() {
        if (pausado) return;
        const maximo = pista.scrollWidth - pista.clientWidth;
        if (maximo <= 2) return;
        if (pista.scrollLeft >= maximo - 2) {
          pista.scrollTo({ left: 0, behavior: movimientoReducido ? 'auto' : 'smooth' });
        } else {
          desplazar(1);
        }
      }

      function arrancar() {
        if (raiz.dataset.automatico !== 'true' || movimientoReducido || temporizador) return;
        const segundos = parseFloat(raiz.dataset.intervalo) || 5;
        temporizador = setInterval(avanzarAutomatico, segundos * 1000);
      }

      if (anterior) anterior.addEventListener('click', function () { desplazar(-1); });
      if (siguiente) siguiente.addEventListener('click', function () { desplazar(1); });

      ['mouseenter', 'focusin', 'touchstart'].forEach(function (evento) {
        raiz.addEventListener(evento, function () { pausado = true; }, { passive: true });
      });
      ['mouseleave', 'focusout', 'touchend'].forEach(function (evento) {
        raiz.addEventListener(evento, function () { pausado = false; }, { passive: true });
      });

      pista.addEventListener('scroll', actualizar, { passive: true });
      window.addEventListener('resize', actualizar);
      window.addEventListener('load', actualizar);
      actualizar();
      arrancar();
    }

    function iniciar() {
      document.querySelectorAll('[data-azurel-ingredientes]').forEach(function (raiz) {
        if (raiz.dataset.iniciado === 'true') return;
        raiz.dataset.iniciado = 'true';
        preparar(raiz);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', iniciar);
    } else {
      iniciar();
    }

    document.addEventListener('shopify:section:load', iniciar);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["opiniones"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    const movimientoReducido = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function preparar(raiz) {
      const pista = raiz.querySelector('[data-azurel-pista]');
      const anterior = raiz.querySelector('[data-azurel-anterior]');
      const siguiente = raiz.querySelector('[data-azurel-siguiente]');
      const relleno = raiz.querySelector('[data-azurel-relleno]');
      const controles = raiz.querySelector('[data-azurel-controles]');
      if (!pista) return;

      let temporizador = null;
      let pausado = false;

      function paso() {
        const item = pista.querySelector('.azurel-resenas__item');
        if (!item) return pista.clientWidth;
        const hueco = parseFloat(window.getComputedStyle(pista).columnGap) || 0;
        return item.getBoundingClientRect().width + hueco;
      }

      function actualizar() {
        const maximo = pista.scrollWidth - pista.clientWidth;
        const hayDesplazamiento = maximo > 2;
        if (controles) controles.hidden = !hayDesplazamiento;
        if (!hayDesplazamiento) return;

        const proporcion = (pista.clientWidth / pista.scrollWidth) * 100;
        const avance = pista.scrollLeft / maximo;
        if (relleno) {
          relleno.style.width = proporcion + '%';
          relleno.style.left = avance * (100 - proporcion) + '%';
        }
        if (anterior) anterior.disabled = pista.scrollLeft <= 2;
        if (siguiente) siguiente.disabled = pista.scrollLeft >= maximo - 2;
      }

      function desplazar(direccion) {
        pista.scrollBy({ left: direccion * paso(), behavior: movimientoReducido ? 'auto' : 'smooth' });
      }

      function avanzarAutomatico() {
        if (pausado) return;
        const maximo = pista.scrollWidth - pista.clientWidth;
        if (maximo <= 2) return;
        if (pista.scrollLeft >= maximo - 2) {
          pista.scrollTo({ left: 0, behavior: movimientoReducido ? 'auto' : 'smooth' });
        } else {
          desplazar(1);
        }
      }

      function arrancar() {
        if (raiz.dataset.automatico !== 'true' || movimientoReducido || temporizador) return;
        const segundos = parseFloat(raiz.dataset.intervalo) || 6;
        temporizador = setInterval(avanzarAutomatico, segundos * 1000);
      }

      if (anterior) anterior.addEventListener('click', function () { desplazar(-1); });
      if (siguiente) siguiente.addEventListener('click', function () { desplazar(1); });

      ['mouseenter', 'focusin', 'touchstart'].forEach(function (evento) {
        raiz.addEventListener(evento, function () { pausado = true; }, { passive: true });
      });
      ['mouseleave', 'focusout', 'touchend'].forEach(function (evento) {
        raiz.addEventListener(evento, function () { pausado = false; }, { passive: true });
      });

      pista.addEventListener('scroll', actualizar, { passive: true });
      window.addEventListener('resize', actualizar);
      window.addEventListener('load', actualizar);
      actualizar();
      arrancar();
    }

    function iniciar() {
      document.querySelectorAll('[data-azurel-resenas]').forEach(function (raiz) {
        if (raiz.dataset.iniciado === 'true') return;
        raiz.dataset.iniciado = 'true';
        preparar(raiz);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', iniciar);
    } else {
      iniciar();
    }

    document.addEventListener('shopify:section:load', iniciar);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["videos"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    const movimientoReducido = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function dosDigitos(valor) {
      return valor < 10 ? '0' + valor : String(valor);
    }

    function prepararCarrusel(raiz) {
      const pista = raiz.querySelector('[data-azurel-pista]');
      const anterior = raiz.querySelector('[data-azurel-anterior]');
      const siguiente = raiz.querySelector('[data-azurel-siguiente]');
      const relleno = raiz.querySelector('[data-azurel-relleno]');
      const controles = raiz.querySelector('[data-azurel-controles]');
      if (!pista) return;

      function paso() {
        const item = pista.querySelector('.azurel-videos__item');
        if (!item) return pista.clientWidth;
        const hueco = parseFloat(window.getComputedStyle(pista).columnGap) || 0;
        return item.getBoundingClientRect().width + hueco;
      }

      function actualizar() {
        const maximo = pista.scrollWidth - pista.clientWidth;
        const hayDesplazamiento = maximo > 2;
        if (controles) controles.hidden = !hayDesplazamiento;
        if (!hayDesplazamiento) return;

        const proporcion = (pista.clientWidth / pista.scrollWidth) * 100;
        const avance = pista.scrollLeft / maximo;
        if (relleno) {
          relleno.style.width = proporcion + '%';
          relleno.style.left = avance * (100 - proporcion) + '%';
        }
        if (anterior) anterior.disabled = pista.scrollLeft <= 2;
        if (siguiente) siguiente.disabled = pista.scrollLeft >= maximo - 2;
      }

      function desplazar(direccion) {
        pista.scrollBy({ left: direccion * paso(), behavior: movimientoReducido ? 'auto' : 'smooth' });
      }

      if (anterior) anterior.addEventListener('click', function () { desplazar(-1); });
      if (siguiente) siguiente.addEventListener('click', function () { desplazar(1); });

      pista.addEventListener('scroll', actualizar, { passive: true });
      window.addEventListener('resize', actualizar);
      window.addEventListener('load', actualizar);
      actualizar();
    }

    function prepararPrevisualizaciones(raiz) {
      if (raiz.dataset.previsualizar !== 'true' || movimientoReducido) return;
      const videos = raiz.querySelectorAll('[data-azurel-previa]');
      if (!videos.length || !('IntersectionObserver' in window)) return;

      const observador = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (entrada) {
          const video = entrada.target;
          if (entrada.isIntersecting) {
            if (!video.getAttribute('src')) video.setAttribute('src', video.dataset.src);
            const promesa = video.play();
            if (promesa && promesa.catch) promesa.catch(function () {});
          } else {
            video.pause();
          }
        });
      }, { threshold: 0.6 });

      videos.forEach(function (video) {
        video.muted = true;
        video.addEventListener('playing', function () {
          video.classList.add('azurel-videos__previa--activa');
        });
        observador.observe(video);
      });
    }

    function crearReproductor(datos) {
      if (datos.tipo === 'mp4') {
        const video = document.createElement('video');
        video.className = 'azurel-videos__reproductor';
        video.controls = true;
        video.autoplay = true;
        video.playsInline = true;
        video.setAttribute('playsinline', '');
        if (datos.posterGrande) video.poster = datos.posterGrande;
        video.src = datos.src;
        return video;
      }

      if (datos.tipo === 'youtube' || datos.tipo === 'vimeo') {
        const marco = document.createElement('iframe');
        marco.className = 'azurel-videos__reproductor';
        marco.src = datos.tipo === 'youtube'
          ? 'https://www.youtube.com/embed/' + datos.src + '?autoplay=1&rel=0&playsinline=1&modestbranding=1'
          : 'https://player.vimeo.com/video/' + datos.src + '?autoplay=1&playsinline=1';
        marco.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
        marco.setAttribute('allowfullscreen', '');
        marco.title = datos.titulo || 'Vídeo';
        return marco;
      }

      const imagen = document.createElement('img');
      imagen.className = 'azurel-videos__reproductor';
      imagen.alt = datos.titulo || '';
      if (datos.posterGrande) imagen.src = datos.posterGrande;
      return imagen;
    }

    function prepararVisor(raiz) {
      const visor = raiz.querySelector('[data-azurel-visor]');
      const tarjetas = Array.prototype.slice.call(raiz.querySelectorAll('[data-azurel-tarjeta]'));
      if (!visor || !tarjetas.length) return;

      const escenario = visor.querySelector('[data-azurel-escenario]');
      const titulo = visor.querySelector('[data-azurel-visor-titulo]');
      const subtitulo = visor.querySelector('[data-azurel-visor-subtitulo]');
      const enlace = visor.querySelector('[data-azurel-visor-enlace]');
      const contador = visor.querySelector('[data-azurel-visor-contador]');
      const botonAnterior = visor.querySelector('[data-azurel-visor-anterior]');
      const botonSiguiente = visor.querySelector('[data-azurel-visor-siguiente]');
      const botonCerrar = visor.querySelector('[data-azurel-cerrar-boton]');
      const cierres = visor.querySelectorAll('[data-azurel-cerrar]');
      let indice = 0;
      let anteriorFoco = null;
      let inicioX = null;

      function mostrar(nuevoIndice) {
        indice = (nuevoIndice + tarjetas.length) % tarjetas.length;
        const datos = tarjetas[indice].dataset;

        escenario.textContent = '';
        escenario.appendChild(crearReproductor(datos));

        titulo.textContent = datos.titulo || '';
        titulo.hidden = !datos.titulo;
        subtitulo.textContent = datos.subtitulo || '';
        subtitulo.hidden = !datos.subtitulo;

        if (datos.enlace) {
          enlace.href = datos.enlace;
          enlace.textContent = datos.textoEnlace || 'Ver producto';
          enlace.hidden = false;
        } else {
          enlace.hidden = true;
        }

        contador.textContent = dosDigitos(indice + 1) + ' / ' + dosDigitos(tarjetas.length);
      }

      function abrir(nuevoIndice) {
        anteriorFoco = document.activeElement;
        mostrar(nuevoIndice);
        visor.classList.add('azurel-videos__visor--abierto');
        visor.setAttribute('aria-hidden', 'false');
        document.documentElement.classList.add('azurel-videos-bloqueado');
        setTimeout(function () {
          if (botonCerrar) botonCerrar.focus();
        }, 60);
      }

      function cerrar() {
        visor.classList.remove('azurel-videos__visor--abierto');
        visor.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('azurel-videos-bloqueado');
        escenario.textContent = '';
        if (anteriorFoco && anteriorFoco.focus) anteriorFoco.focus();
      }

      tarjetas.forEach(function (tarjeta, posicion) {
        tarjeta.addEventListener('click', function () {
          abrir(posicion);
        });
      });

      cierres.forEach(function (elemento) {
        elemento.addEventListener('click', cerrar);
      });

      if (botonAnterior) botonAnterior.addEventListener('click', function () { mostrar(indice - 1); });
      if (botonSiguiente) botonSiguiente.addEventListener('click', function () { mostrar(indice + 1); });

      visor.addEventListener('keydown', function (evento) {
        if (evento.key === 'Escape') {
          cerrar();
          return;
        }
        if (evento.key === 'ArrowLeft') {
          mostrar(indice - 1);
          return;
        }
        if (evento.key === 'ArrowRight') {
          mostrar(indice + 1);
          return;
        }
        if (evento.key !== 'Tab') return;

        const enfocables = Array.prototype.slice.call(visor.querySelectorAll('button:not([disabled]), a[href]')).filter(function (elemento) {
          return elemento.offsetParent !== null;
        });
        if (!enfocables.length) return;

        const primero = enfocables[0];
        const ultimo = enfocables[enfocables.length - 1];

        if (evento.shiftKey && document.activeElement === primero) {
          evento.preventDefault();
          ultimo.focus();
        } else if (!evento.shiftKey && document.activeElement === ultimo) {
          evento.preventDefault();
          primero.focus();
        }
      });

      visor.addEventListener('touchstart', function (evento) {
        inicioX = evento.changedTouches[0].clientX;
      }, { passive: true });

      visor.addEventListener('touchend', function (evento) {
        if (inicioX === null) return;
        const diferencia = evento.changedTouches[0].clientX - inicioX;
        inicioX = null;
        if (Math.abs(diferencia) > 60) mostrar(indice + (diferencia < 0 ? 1 : -1));
      });
    }

    function iniciar() {
      document.querySelectorAll('[data-azurel-videos]').forEach(function (raiz) {
        if (raiz.dataset.iniciado === 'true') return;
        raiz.dataset.iniciado = 'true';
        prepararCarrusel(raiz);
        prepararPrevisualizaciones(raiz);
        prepararVisor(raiz);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', iniciar);
    } else {
      iniciar();
    }

    document.addEventListener('shopify:section:load', iniciar);

    document.addEventListener('shopify:section:unload', function () {
      document.documentElement.classList.remove('azurel-videos-bloqueado');
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
